module.exports = __webpack_public_path__ + "img/tariff-like.94000f17.svg";